import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {PartnerSummaryConverter} from './partnerSummary.converter';
import {PartnerModel} from '../model/partner.model';
import {Injectable} from "@angular/core";
import {PartnerAddressConverter} from "./partnerAddress.converter";
import {PartnerPersonSummaryConverter} from "../../../modules/person/api/converter/partnerPersonSummary.converter";
import {
    MarketingChannelSummaryConverter
} from "../../../../marketing/channel/converter/marketingChannelSummary.converter";
import {LovValueSummaryConverter} from "../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";

@Injectable({
  providedIn: 'root',
})
export class PartnerConverter extends HttpModelConverter<PartnerModel>{

    constructor(private partnerSummaryConverter: PartnerSummaryConverter,
                private partnerAddressConverter: PartnerAddressConverter,
                private partnerPersonSummaryConverter: PartnerPersonSummaryConverter,
                private marketingChannelSummaryConverter: MarketingChannelSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter){
        super();
    }

    protected createInstance(): PartnerModel {
        return new PartnerModel();
    }

    protected enrichObject(result: PartnerModel, src: PartnerModel) {
        result.summary = this.partnerSummaryConverter.convert(src.summary);
        result.addresses = this.partnerAddressConverter.convertFromArray(src.addresses);
        result.persons = this.partnerPersonSummaryConverter.convertFromArray(src.persons);
        result.marketingChannels = this.marketingChannelSummaryConverter.convertFromArray(src.marketingChannels);
        result.parents = src.parents.map(value => {
            return {
                partnerId: value.partnerId,
                type: this.lovValueSummaryConverter.convert(value.type)
            };
        })
    }
}
